import { DataGrid } from "devextreme-react";
import React, { useMemo } from "react";
import { useDataSource } from "../../../../contexts/dataSource";
import { Column, Editing, Form, Popup, RequiredRule } from "devextreme-react/data-grid";
import { getPropsDataGrid, getPropsDataGridEditing, getPropsDataGridPopup } from "../../../../utils/default-props";
import { Item } from "devextreme-react/form";
import { useAuth } from "../../../../contexts/auth";
import { getDataGridCustomToolbar } from "../../../../components/default-components/data-grid-custom-toolbar";

function DectriptionManagement(props) {

    const { dataSourceHR } = useDataSource()
    const {getListPermissionProps} = useAuth()
    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: props.loadUrl,
        insertUrl: props.insertUrl
    }), [])

    const title = props.title
    const editingParams = //getListPermissionProps(props.section)
    {
        allowAdding : true,
        allowDeleting: true,
        allowUpdating: true
    }
    editingParams.mode = "popup"

    return (
        <React.Fragment>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    {/* <div className="grid-caption">{title} Yönetimi</div> */}
                    <DataGrid
                        {...getPropsDataGrid}
                        maxWidth={500}
                        dataSource={dataSource}
                    >
                        {getDataGridCustomToolbar(title +  " Tanımları")}
                        <Editing {...getPropsDataGridEditing}>
                            <Popup title={`${title} Bilgisi`} {...getPropsDataGridPopup} />
                            <Form >
                                <Item dataField="name" colSpan={2}></Item>
                            </Form>
                        </Editing>
                        <Column dataField="name" caption={`${title} Adı`} ><RequiredRule /> </Column>
                    </DataGrid>
                </div>
            </div>
        </React.Fragment>
    )
}


export function BranchManagement() {
    return <DectriptionManagement loadUrl="/api/BranchInfo" insertUrl="/api/BranchInfo/FormData" title="Şube" section="Hr_Branch" />
}
export function CompanyManagement() {
    return <DectriptionManagement loadUrl="/api/CompanyInfo" insertUrl="/api/CompanyInfo/FormData" title="Şirket" section="Hr_Company" />
}
export function DepartmentManagement() {
    return <DectriptionManagement loadUrl="/api/DepartmentInfo" insertUrl="/api/DepartmentInfo/FormData" title="Departman" section="Hr_Department" />
}
export function OfficeManagement() {
    return <DectriptionManagement loadUrl="/api/OfficeInfo" insertUrl="/api/OfficeInfo/FormData" title="Ofis" section="Hr_Office" />
}
export function TitleManagement() {
    return <DectriptionManagement loadUrl="/api/TitleInfo" insertUrl="/api/TitleInfo/FormData" title="Ünvan" section="Hr_Title" />
}
export function BankInfo() {
    return <DectriptionManagement loadUrl="/api/BankInfo" insertUrl="/api/BankInfo/FormData" title="Banka" section="Hr_Bank" />
}
export function ShiftInfo() {
    return <DectriptionManagement loadUrl="/api/ShiftInfo" insertUrl="/api/ShiftInfo/FormData" title="Vardiya" section="Hr_Shift" />
}
export function GroupManagement() {
    return <DectriptionManagement loadUrl="/api/Group" insertUrl="/api/Group/FormData" title="Grup" section="Hr_Group" />
}
export function CertificateCategoryInfo() {
    return <DectriptionManagement loadUrl="/api/CertificateCategoryInfo" insertUrl="/api/CertificateCategoryInfo/FormData" title="Sertifika Kategori" section="Hr_Group" />
}
export function EmployeeDocumentInfo() {
    return <DectriptionManagement loadUrl="/api/EmployeeDocumentInfo" insertUrl="/api/EmployeeDocumentInfo/FormData" title="Doküman Tipi" section="Hr_Group" />
}